import React from 'react'
import Button from '../Button/Button'
import './EnrolButton.css'

const ENROL_URL = 'https://pvmconsulting.formstack.com/forms/cccregistrationform'

const EnrolButton = () => {
  return (
    <Button 
      href={ENROL_URL} 
      target='_blank'
      text='Enrol Now' 
      className='cta-button'
    />
  )
}

export default EnrolButton

